module.exports = __webpack_public_path__ + "static/media/features.54af723c.png";